import Command from './command';
import CommandResult from './command-result';
import ConvertCommand from './convert-selection';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
export default Command.extend({
  processZeroWidth() {
    return CommandResult.create();
  },
  processSingleBlock() {
    this._validateDirection();
    if (this.get('firstSelectedBlock.canAlign')) {
      if (this.get('isFirstSelectedBlockCovered')) {
        this.set('firstSelectedBlock.align', this.get('options.direction'));
        return CommandResult.create();
      }
      if (this._shouldExpandToLineBreaks()) {
        this._expandSelectionToLineBreaks();
      }
      // ConvertCommand already has exactly the behaviour we want
      ConvertCommand.create({
        blockList: this.get('blockList'),
        selection: this.get('selection'),
        options: {
          blockType: this.get('firstSelectedBlock.type')
        },
        config: this.get('config')
      }).run();
      this.set('selection.firstSelectedBlock.align', this.get('options.direction'));
    }
    return CommandResult.create();
  },
  processMultiBlock() {
    this._validateDirection();
    if (this.get('allBlocksCovered')) {
      return this._alignSelectedBlocks();
    }
    let newStartBlock = this.get('firstSelectedBlock');
    let newEndBlock = this.get('lastSelectedBlock');
    if (this.get('firstSelectedBlockNotCoveredAndNotList')) {
      newStartBlock = this.get('firstSelectedBlock').applyAction('split', BlockRange.atPositionIndex(this.get('selection.startPositionIndex')));
      this.insertBlock(newStartBlock);
    }
    if (this.get('lastSelectedBlockNotCoveredAndNotList')) {
      newEndBlock = this.get('lastSelectedBlock').applyAction('split', BlockRange.atPositionIndex(this.get('selection.endPositionIndex')));
      this.insertBlock(newEndBlock, this._blockIndex(this.get('lastSelectedBlock')) + 1);
    }
    this.setSelectionToCoverBlocks(newStartBlock, this.get('lastSelectedBlock'));
    return this._alignSelectedBlocks();
  },
  _shouldExpandToLineBreaks() {
    return this.get('firstSelectedBlock.isParagraph') || this.get('firstSelectedBlock.isHeadingType');
  },
  _alignSelectedBlocks() {
    let direction = this.get('options.direction');
    let selectedBlocks = this.get('selection.selectedBlocks');
    selectedBlocks.forEach(function (block) {
      if (block.get('canAlign')) {
        block.set('align', direction);
      }
    });
    return CommandResult.create();
  },
  _expandSelectionToLineBreaks() {
    let startPositionIndex = this._getIndexOfPreviousLineBreak();
    let endPositionIndex = this._getIndexOfNextLineBreak();
    this.setSelectionToPositionIndex(startPositionIndex, endPositionIndex);
  },
  _getIndexOfPreviousLineBreak() {
    let leftOfSelection = this.get('firstSelectedBlock.text').slice(0, this.get('selection.startPositionIndex'));
    let newStartPositionIndex = leftOfSelection.lastIndexOf('\n');
    if (newStartPositionIndex === -1) {
      newStartPositionIndex = 0;
    } else {
      newStartPositionIndex++;
    }
    return newStartPositionIndex;
  },
  _getIndexOfNextLineBreak() {
    let blockText = this.get('firstSelectedBlock.text');
    let rightOfSelection = blockText.slice(this.get('selection.endPositionIndex'));
    let newEndPositionIndex = rightOfSelection.indexOf('\n');
    if (newEndPositionIndex === -1) {
      newEndPositionIndex = blockText.length;
    } else {
      newEndPositionIndex += this.get('selection.endPositionIndex');
    }
    return newEndPositionIndex;
  },
  _validateDirection() {
    if (!['left', 'right', 'center'].includes(this.get('options.direction'))) {
      throw new Error('Invalid direction');
    }
  }
});